import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=60e30882&scoped=true"
import script from "./duration.vue?vue&type=script&lang=js"
export * from "./duration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e30882",
  null
  
)

export default component.exports